var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('LeftView'),_c('TopView'),_c('v-main',{staticClass:"pa-0 widthfull"},[_c('v-content',{staticClass:"widthfull colorGradient"},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }